"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingBoxRadioButtonViewChoosed = exports.SettingBoxRadioButtonViewDefault = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styles_1 = require("@material-ui/styles");
var PropTypes = tslib_1.__importStar(require("prop-types"));
var Icon_1 = tslib_1.__importDefault(require("@material-ui/core/Icon"));
var useStyle = styles_1.makeStyles(function (theme) { return ({
    Wrap: function (newType) { return ({
        width: 660,
        height: newType.height,
        marginBottom: 8,
        "&:hover": {
            cursor: "pointer",
        },
    }); },
    borderDefault: {
        display: "flex",
        flexDirection: "column",
        padding: 10,
        fontWeight: 500,
        fontSize: 16,
        backgroundColor: theme
            ? theme.app.SettingBoxRadioButtonGroupView.backgroundColor
            : "",
        borderStyle: "solid",
        borderWidth: 1,
        borderRadius: 3,
        borderColor: theme
            ? theme.app.SettingBoxRadioButtonGroupView.borderColor
            : "",
    },
    borderChoosed: function (newType) { return ({
        display: "flex",
        flexDirection: "column",
        backgroundColor: newType.backgroundColor,
        color: "rgb(255, 255, 255)",
        padding: 11,
        fontWeight: 500,
        fontSize: 16,
        borderStyle: "solid",
        borderWidth: 1,
        borderRadius: 3,
        borderColor: newType.backgroundColor,
    }); },
    radioIconDefault: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 24,
        height: 24,
        marginRight: 8,
        color: theme
            ? theme.app.SettingBoxRadioButtonGroupView.radioIconDefaultColor
            : "",
    },
    radioIconcChoosed: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 24,
        height: 24,
        marginRight: 8,
        color: theme
            ? theme.app.SettingBoxRadioButtonGroupView.radioIconChoosedColor
            : "",
    },
    radioBoxContentChoosed: function (newType) { return ({
        display: "flex",
        flexDirection: "column",
        backgroundColor: newType.backgroundColor,
        color: "rgb(255, 255, 255)",
        padding: 11,
        fontWeight: 500,
        fontSize: 16,
    }); },
    radioBoxContentText: {
        display: "flex",
        alignItems: "center",
        height: 24,
    },
    radioBoxContentDesDefault: {
        display: "flex",
        alignItems: "center",
        height: 18,
        marginLeft: 32,
        marginTop: 4,
        fontSize: 14,
        fontWeight: 400,
        color: theme
            ? theme.app.SettingBoxRadioButtonGroupView
                .radioBoxContentDesDefaultColor
            : "",
    },
    radioBoxContentDesChoosed: {
        display: "flex",
        alignItems: "center",
        height: 18,
        marginLeft: 32,
        marginTop: 4,
        fontSize: 14,
        fontWeight: 400,
        color: theme
            ? theme.app.SettingBoxRadioButtonGroupView
                .radioBoxContentDesChoosedColor
            : "",
    },
    divider: {
        opacity: 0.3,
    },
    textDefault: {
        color: theme ? theme.app.Setting.color3 : "",
    },
    textDefaultColor: function (newType) { return ({
        color: newType.Color,
    }); },
}); });
function SettingBoxRadioButtonViewDefault(props) {
    var text = props.text, des = props.des, color = props.color, onClick = props.onClick;
    var newType = {
        Color: color,
        height: des !== undefined ? 66 : 44,
    };
    var classes = useStyle(newType);
    var handleOption = function (newOption) {
        onClick(newOption);
    };
    return (React.createElement("div", { className: classes.Wrap, onClick: function () { return handleOption(text); } },
        React.createElement("div", { className: classes.borderDefault },
            React.createElement("div", { className: classes.radioBoxContentText },
                React.createElement("div", { className: classes.radioIconDefault },
                    React.createElement(Icon_1.default, { style: { fontSize: 28 } }, "check_box_outline_blank")),
                color !== undefined && (React.createElement("span", { className: classes.textDefaultColor },
                    " ",
                    text)),
                color === undefined && (React.createElement("span", { className: classes.textDefault },
                    " ",
                    text))),
            des !== undefined && (React.createElement("div", { className: classes.radioBoxContentDesDefault }, des)))));
}
exports.SettingBoxRadioButtonViewDefault = SettingBoxRadioButtonViewDefault;
function SettingBoxRadioButtonViewChoosed(props) {
    var text = props.text, des = props.des, color = props.color, onClick = props.onClick;
    var newType = {
        backgroundColor: color,
        height: des !== undefined ? 66 : 44,
    };
    var classes = useStyle(newType);
    var handleOption = function (newoption) {
        onClick(newoption);
    };
    return (React.createElement("div", { className: classes.Wrap, onClick: function () { return handleOption(text); } },
        React.createElement("div", { className: classes.borderChoosed },
            React.createElement("div", { className: classes.radioBoxContentText },
                React.createElement("div", { className: classes.radioIconcChoosed },
                    React.createElement(Icon_1.default, { style: { fontSize: 28 } }, "check_box")),
                React.createElement("span", null,
                    text,
                    " ")),
            des !== undefined && (React.createElement("div", { className: classes.radioBoxContentDesChoosed }, des)))));
}
exports.SettingBoxRadioButtonViewChoosed = SettingBoxRadioButtonViewChoosed;
SettingBoxRadioButtonViewChoosed.protoTypes = {
    color: PropTypes.string,
};
SettingBoxRadioButtonViewChoosed.defaultProps = {
    color: "rgb(114,137,218)",
};
//# sourceMappingURL=SettingBoxRadioButtonView.js.map